import React from 'react';
import { View, StyleSheet, TouchableOpacity, Image } from 'react-native';
import { PnmacText } from 'pnmac-universal-components';
import { textStyle } from '../v2/theme';
export default function PnmacOffersAccordion(props) {
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.mainContainer, {
      marginBottom: props.item.expanded ? 10 : 20,
      height: !props.item.expanded ? "15%" : null,
      paddingBottom: 10
    }]
  }, /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: function () {
      if (props.onPress) {
        props.onPress();
      }
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.innerContainer
  }, /*#__PURE__*/React.createElement(View, {
    style: [styles.itemIconContainer, {
      flexGrow: 1
    }]
  }, /*#__PURE__*/React.createElement(Image, {
    source: props.item.icon,
    style: styles.itemIconStyle
  })), /*#__PURE__*/React.createElement(View, {
    style: [styles.titleContainer, {
      marginLeft: 5,
      flex: 1,
      width: "100%",
      alignContent: 'center',
      alignSelf: "stretch",
      flexGrow: props.childrenContent ? 10 : 4,
      flexDirection: "row"
    }]
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      width: "95%"
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: [textStyle.accordionItem, {
      textAlign: "left",
      marginTop: 15,
      color: props.item.expanded ? "#003087" : "#333333"
    }]
  }, props.title)), /*#__PURE__*/React.createElement(View, {
    style: [styles.chevronContainer]
  }, /*#__PURE__*/React.createElement(Image, {
    style: styles.chevronIconStyle,
    resizeMode: "contain",
    source: props.item.expanded ? require("../assets/icon-chevron-up.png") : require("../assets/icon-chevron-down.png")
  }))))), /*#__PURE__*/React.createElement(View, {
    style: {
      marginHorizontal: 10,
      borderBottomColor: !props.isLastItem ? 'rgba(128, 128, 128, 0.3)' : "transparent",
      borderBottomWidth: 0.1,
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, props.item.expanded && (/*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacText, {
    numberOfLines: 2,
    style: [textStyle.nonActiveTabText, {
      textAlign: "left",
      fontFamily: "HalenoirCompactText-Regular",
      marginLeft: props.childrenContent ? '8%' : '18%',
      fontSize: 13,
      paddingBottom: 20
    }]
  }, props.description), props.childrenContent && props.childrenContent)))));
}
;
var styles = StyleSheet.create({
  mainContainer: {
    paddingBottom: 10
  },
  innerContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between"
  },
  itemIconStyle: {
    width: 41,
    height: 40,
    padding: 5,
    alignSelf: "center"
  },
  itemIconContainer: {
    flex: 1
  },
  titleContainer: {},
  chevronContainer: {
    justifyContent: "center",
    alignItems: "center"
  },
  chevronIconStyle: {
    width: 14,
    height: 9,
    tintColor: "#777777"
  }
});